/**
* Videoのコンストラクタ
* @constructor
* @param {selector} - el jqueryセレクタ
*/
module.exports = Video = function(el){
  this.element = $(el);
  this.state = $('.js-hamburger-state');
  this.target = this.element.find('video');
  this.win = $(window);
  this.checkDevice();
  this.event();
};

/**
* event
*/
Video.prototype.event = function(){
  var self = this;

  var poster = this.element.find('video').attr('poster');
  var $control = this.element.find('.js-video-control');

  $control.css('background-image', 'url('+poster+')').on('click', function(e){
    e.preventDefault();
    console.log('123');
    var $parent = $(this).parent();
    var videoId = $(this).attr('data-video-id');
    var $video = $('#'+videoId).get(0);
    $parent.addClass('is-clicked');
    $('#'+videoId).attr('controls', true);
    if($video.paused){
      $video.play();
    }else{
      $video.pause();
    }
  });
};

/**
* デバイスチェック
*/
Video.prototype.checkDevice = function(){
  var isSP = this.state.is(':visible');
  if(isSP){
    this.device = 'sp';
  }else{
    this.device = 'pc';
  }
}



//////////////////
// WEBPACK FOOTER
// ./js/_modules/video.js
// module id = 10
// module chunks = 0